import get from 'lodash/get'
import { connect } from 'react-redux'

import MapView from './MapView'
import marker from '@img/marker.svg'
import markerSelected from '@img/markerSelected.svg'


export default connect((state, { additionalLocations = [] }) => ({
  locations: [...additionalLocations, {
    ...get(state, 'schoolNewServices.data.static_content.location', {}),
    rating: get(state, 'schoolNewServices.data.static_content.rating.overall'),
    name: get(state, 'schoolNewServices.data.name'),
  }],
  infoWindowContent: '<div><%= name %></div><div><%= rating %> / 5</div>',
  markerIcon: marker,
  markerIconSelected: markerSelected,
  openAllMarkers: true,
}))(MapView)
